import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-plugIn",
  "use": "icon-plugIn-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-plugIn\"><defs><style type=\"text/css\"></style></defs><path d=\"M864 128h-56.64a32 32 0 0 0 0 64H864a32 32 0 0 1 32 32v640a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V224a32 32 0 0 1 32-32h62.272a32 32 0 0 0 0-64H160a96 96 0 0 0-96 96v640a96 96 0 0 0 96 96h704a96 96 0 0 0 96-96V224a96 96 0 0 0-96-96z\" p-id=\"5044\" /><path d=\"M341.216 308.32L480 185.312V688a32 32 0 0 0 64 0V185.312l138.784 123.008a32.032 32.032 0 0 0 42.464-47.904l-192-170.208a32 32 0 0 0-42.464 0l-192 170.208a32 32 0 1 0 42.432 47.904z\" p-id=\"5045\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/plugIn.svg
// module id = MATk
// module chunks = 78